"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Image = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Image"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _utils = require("../utils");
var _ViewportProvider = require("../ViewportProvider");
var _ThemeProvider = require("../ThemeProvider");
var _Link = require("../Link");
var _StackView = require("../StackView");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// pass through and type relevant system props - add more sets for interactive components
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.linkProps]);
const selectImageStyle = imageDimension => ({
  width: imageDimension,
  height: imageDimension,
  ..._Platform.default.select({
    // TODO: https://github.com/telus/universal-design-system/issues/487
    web: {
      transition: 'width 200ms, height 200ms'
    }
  })
});
const selectContainerStyle = _ref => {
  let {
    contentMaxDimension,
    textAlign
  } = _ref;
  return {
    textAlign,
    outline: 'red',
    width: contentMaxDimension,
    overflow: 'hidden'
  };
};
const selectImageContainerStyle = contentMaxDimension => ({
  width: contentMaxDimension,
  height: contentMaxDimension,
  justifyContent: 'center',
  alignItems: 'center'
});
const selectLinkToken = _ref2 => {
  let {
    outerBorderColor
  } = _ref2;
  return {
    outerBorderColor
  };
};

/**
 * Component export along with QuickLinksFeature to be used as children
 *
 * It will receive a image source and a accessibility label and will render a link accordingly with the theme tokens
 */
const QuickLinksFeatureItem = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    tokens,
    variant,
    children,
    imageAccessibilityLabel,
    imageSource,
    ...rest
  } = _ref3;
  const viewport = (0, _ViewportProvider.useViewport)();
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('QuickLinksFeatureItem', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
    ref: ref,
    ...selectProps(rest),
    tokens: state => selectLinkToken(getTokens(state)),
    children: _ref4 => {
      let {
        hovered: hover,
        pressed,
        focused: focus
      } = _ref4;
      const {
        contentDirection,
        contentSpace,
        contentAlignItems,
        contentMaxDimension,
        imageDimension,
        textLine,
        gap,
        ...themeTokens
      } = getTokens({
        viewport,
        hover,
        pressed,
        focus
      });
      const textStyle = {
        ...(0, _ThemeProvider.applyTextStyles)(themeTokens),
        textDecorationLine: textLine
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: selectContainerStyle({
          ...themeTokens,
          contentMaxDimension
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackView.StackWrap, {
          direction: contentDirection,
          space: contentSpace,
          gap: gap,
          tokens: {
            alignItems: contentAlignItems
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
            style: selectImageContainerStyle(contentMaxDimension),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
              accessibilityIgnoresInvertColors: true,
              imageAccessibilityLabel: imageAccessibilityLabel,
              source: imageSource,
              style: selectImageStyle(imageDimension)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              style: textStyle,
              children: children
            })]
          })
        })
      });
    }
  });
});
QuickLinksFeatureItem.displayName = 'QuickLinksFeatureItem';
QuickLinksFeatureItem.propTypes = {
  ..._utils.withLinkRouter.propTypes,
  ...selectedSystemPropTypes,
  tokens: (0, _utils.getTokensPropType)('QuickLinksFeatureItem'),
  variant: _utils.variantProp.propType,
  /**
   * Text which will be rendered within the Link
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Image accessibility label
   */
  imageAccessibilityLabel: _propTypes.default.string.isRequired,
  /**
   * Image node or Image url
   */
  imageSource: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired
};
var _default = exports.default = (0, _utils.withLinkRouter)(QuickLinksFeatureItem);